(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novaria-conversion-sticky"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('novaria-conversion-sticky')){customElements.define('novaria-conversion-sticky',class extends HTMLElement{connectedCallback(){this.button=this.querySelector('[data-sticky-button]');this.current=this.querySelector('[data-current-price]');this.compare=this.querySelector('[data-compare-price]');this.productInfo=document.querySelector('.novaria-conversion-main');this.showCompare=this.dataset.showCompare==='true';if(!this.button||!this.productInfo)return;this.cleanMoney=t=>t.trim().replace(/\s+/g,' ').replace(/\s*CLP\b/gi,'');this.click=()=>{const b=this.productInfo.querySelector('.product-form__submit');if(b&&!b.disabled&&b.getAttribute('aria-disabled')!=='true')b.click()};this.sync=()=>{const b=this.productInfo.querySelector('.product-form__submit');if(!b)return;this.button.disabled=b.disabled||b.getAttribute('aria-disabled')==='true';const p=this.productInfo.querySelector('[id^="price-"] .price');if(p){const sale=p.classList.contains('price--on-sale');const cur=sale?p.querySelector('.price__sale .price-item--sale'):p.querySelector('.price__regular .price-item--regular');const cmp=sale?p.querySelector('.price__sale .price-item--regular'):null;if(cur)this.current.textContent=this.cleanMoney(cur.textContent);if(this.showCompare&&cmp){this.compare.textContent=this.cleanMoney(cmp.textContent);this.compare.hidden=false}else this.compare.hidden=true}if(b!==this.target){if(this.target)this.io.unobserve(this.target);this.target=b;this.io.observe(b)}};this.schedule=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.sync())};this.io=new IntersectionObserver(([e])=>this.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.top<0),{threshold:[0,.01]});this.mo=new MutationObserver(this.schedule);this.mo.observe(this.productInfo,{subtree:true,childList:true,attributes:true,characterData:true});this.button.addEventListener('click',this.click);this.sync()}disconnectedCallback(){this.button?.removeEventListener('click',this.click);this.mo?.disconnect();this.io?.disconnect();cancelAnimationFrame(this.frame)}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novaria-gallery-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const GLOBAL_KEY = 'NovariaHeroGalleryAutoplay';

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].refresh();
    return;
  }

  const manager = {
    instance: null,

    destroy() {
      this.instance?.destroy?.();
      this.instance = null;
    },

    refresh() {
      this.destroy();

      window.requestAnimationFrame(() => {
        const config = document.querySelector('.novaria-gallery-hero--active');
        const gallery = document.querySelector('product-info media-gallery');
        const slider = gallery?.querySelector("[id^='Slider-Gallery-']");

        if (!config || !gallery || !slider) return;
        if (config.dataset.galleryMovement !== 'automatico') return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (reducedMotion.matches) return;

        const seconds = Math.min(12, Math.max(2, Number(config.dataset.galleryInterval) || 5));
        const interval = seconds * 1000;
        const controller = new AbortController();
        const { signal } = controller;
        const pauseReasons = new Set();
        const supportsHover = window.matchMedia('(hover: hover)').matches;
        let timer = null;
        let inView = true;
        let observer = null;

        const slides = () =>
          Array.from(slider.children).filter(
            (item) =>
              item.classList.contains('product__media-item') &&
              !item.hidden &&
              window.getComputedStyle(item).display !== 'none'
          );

        const targetLeft = (item) => Math.max(0, item.offsetLeft - slider.offsetLeft);

        const currentIndex = (items) => {
          if (!items.length) return -1;

          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          items.forEach((item, index) => {
            const distance = Math.abs(targetLeft(item) - slider.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        };

        const canRun = () =>
          !document.hidden &&
          inView &&
          pauseReasons.size === 0 &&
          !reducedMotion.matches;

        const clearTimer = () => {
          if (timer !== null) window.clearTimeout(timer);
          timer = null;
        };

        const schedule = () => {
          clearTimer();
          if (!canRun()) return;

          const items = slides();
          if (items.length < 2) return;

          timer = window.setTimeout(() => {
            timer = null;
            if (!canRun()) return;

            const currentSlides = slides();
            if (currentSlides.length < 2) return;

            const index = Math.max(0, currentIndex(currentSlides));
            const currentSlide = currentSlides[index];
            const playingVideo = currentSlide?.querySelector('video');

            if (playingVideo && !playingVideo.paused && !playingVideo.ended) {
              schedule();
              return;
            }

            const nextSlide = currentSlides[(index + 1) % currentSlides.length];
            slider.scrollTo({
              left: targetLeft(nextSlide),
              behavior: 'smooth',
            });

            schedule();
          }, interval);
        };

        const restart = () => {
          clearTimer();
          schedule();
        };

        const pause = (reason) => {
          pauseReasons.add(reason);
          clearTimer();
        };

        const resume = (reason) => {
          pauseReasons.delete(reason);
          schedule();
        };

        if (supportsHover) {
          gallery.addEventListener('pointerenter', () => pause('hover'), { signal });
          gallery.addEventListener('pointerleave', () => resume('hover'), { signal });
        }

        gallery.addEventListener('pointerdown', () => pause('pointer'), { signal });
        window.addEventListener('pointerup', () => resume('pointer'), { signal });
        window.addEventListener('pointercancel', () => resume('pointer'), { signal });

        gallery.addEventListener('focusin', () => pause('focus'), { signal });
        gallery.addEventListener(
          'focusout',
          (event) => {
            if (!gallery.contains(event.relatedTarget)) resume('focus');
          },
          { signal }
        );

        gallery.addEventListener('click', restart, { signal });
        gallery.addEventListener('keydown', restart, { signal });

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) clearTimer();
            else schedule();
          },
          { signal }
        );

        reducedMotion.addEventListener(
          'change',
          () => {
            if (reducedMotion.matches) clearTimer();
            else schedule();
          },
          { signal }
        );

        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(
            ([entry]) => {
              inView = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.25);
              if (inView) schedule();
              else clearTimer();
            },
            { threshold: [0, 0.25, 0.5] }
          );
          observer.observe(gallery);
        }

        this.instance = {
          destroy() {
            clearTimer();
            controller.abort();
            observer?.disconnect();
          },
        };

        schedule();
      });
    },
  };

  window[GLOBAL_KEY] = manager;

  const refresh = () => manager.refresh();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novaria-product-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__novariaPriceRefreshLoaded) return;
    window.__novariaPriceRefreshLoaded = true;

    let scheduled = false;

    const formatMoney = (amount, currency) => {
      try {
        return new Intl.NumberFormat('es-CL', {
          style: 'currency',
          currency: currency || 'CLP',
          maximumFractionDigits: currency === 'CLP' || !currency ? 0 : 2,
        }).format((Number(amount) || 0) / 100);
      } catch (error) {
        return `$${Math.round((Number(amount) || 0) / 100).toLocaleString('es-CL')}`;
      }
    };

    const refresh = () => {
      scheduled = false;
      const productInfo = document.querySelector("product-info[id^='MainProduct']");
      const priceRoot = productInfo?.querySelector("div[id^='price-']");
      const config = document.querySelector('.novaria-product-enhancer');
      if (!productInfo || !priceRoot || !config) return;

      let variant = null;
      const selected = productInfo.querySelector('variant-selects script[data-selected-variant]');
      const fallback = config.querySelector('[data-novaria-initial-variant]');
      try {
        variant = JSON.parse(selected?.textContent || fallback?.textContent || 'null');
      } catch (error) {
        return;
      }
      if (!variant) return;

      const compare = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || 0);
      const badge = priceRoot.querySelector('.price__badge-sale');
      const showSavings = config.dataset.showSavings !== 'false';
      const onSale = compare > price && price > 0;
      const percent = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
      const expectedBadge = onSale ? `-${percent}%` : '';
      const existingSaving = priceRoot.querySelector('.novaria-live-saving');
      const fingerprint = `${variant.id || ''}:${compare}:${price}:${showSavings}`;
      const alreadySynced =
        priceRoot.dataset.novariaPriceFingerprint === fingerprint &&
        (!onSale || !badge || badge.textContent.trim() === expectedBadge) &&
        (!onSale || !showSavings || existingSaving);

      if (alreadySynced) return;
      priceRoot.dataset.novariaPriceFingerprint = fingerprint;
      existingSaving?.remove();

      if (onSale) {
        if (badge) badge.textContent = expectedBadge;

        if (showSavings) {
          const saving = document.createElement('span');
          saving.className = 'novaria-live-saving';
          saving.textContent = `Ahorras ${formatMoney(compare - price, config.dataset.currency || 'CLP')}`;
          priceRoot.appendChild(saving);
        }
      }
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(refresh);
    };

    const start = () => {
      const productInfo = document.querySelector("product-info[id^='MainProduct']");
      if (!productInfo) return;
      new MutationObserver(schedule).observe(productInfo, { childList: true, subtree: true });
      refresh();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novaria-product-enhancer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__novariaProductEnhancerLoaded) return;
    window.__novariaProductEnhancerLoaded = true;

    const money = (amount, currency) => {
      try {
        return new Intl.NumberFormat('es-CL', {
          style: 'currency',
          currency: currency || 'CLP',
          maximumFractionDigits: currency === 'CLP' || !currency ? 0 : 2,
        }).format((Number(amount) || 0) / 100);
      } catch (error) {
        return `$${Math.round((Number(amount) || 0) / 100).toLocaleString('es-CL')}`;
      }
    };

    const getConfig = () => document.querySelector('.novaria-product-enhancer');

    const patchPrice = (variant) => {
      if (!variant) return;
      const productInfo = document.querySelector("product-info[id^='MainProduct']");
      const priceRoot = productInfo?.querySelector("div[id^='price-']");
      if (!priceRoot) return;

      const compare = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || 0);
      const badge = priceRoot.querySelector('.price__badge-sale');
      const config = getConfig();
      const showSavings = config?.dataset.showSavings !== 'false';
      const currency = config?.dataset.currency || 'CLP';

      priceRoot.querySelector('.novaria-live-saving')?.remove();

      if (compare > price && price > 0) {
        const percent = Math.round(((compare - price) / compare) * 100);
        if (badge) badge.textContent = `-${percent}%`;

        if (showSavings) {
          const saving = document.createElement('span');
          saving.className = 'novaria-live-saving';
          saving.textContent = `Ahorras ${money(compare - price, currency)}`;
          priceRoot.appendChild(saving);
        }
      }
    };

    const initialVariant = () => {
      const selected = document.querySelector('variant-selects script[data-selected-variant]');
      if (selected?.textContent) {
        try { return JSON.parse(selected.textContent); } catch (error) { /* noop */ }
      }
      const fallback = getConfig()?.querySelector('[data-novaria-initial-variant]');
      if (fallback?.textContent) {
        try { return JSON.parse(fallback.textContent); } catch (error) { /* noop */ }
      }
      return null;
    };

    const init = () => {
      patchPrice(initialVariant());
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        patchPrice(data?.variant);
      });
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novaria-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('novaria-sticky-atc')) {
    customElements.define(
      'novaria-sticky-atc',
      class NovariaStickyAtc extends HTMLElement {
        connectedCallback() {
          this.stickyButton = this.querySelector('[data-sticky-button]');
          this.currentPrice = this.querySelector('[data-sticky-current-price]');
          this.comparePrice = this.querySelector('[data-sticky-compare-price]');
          this.productInfo = document.querySelector('product-info');
          this.showCompare = this.dataset.showCompare === 'true';
          if (!this.stickyButton || !this.productInfo) return;

          this.schemaLabel = this.stickyButton.textContent.trim();
          this.cleanMoney = (text) => text.trim().replace(/\s+/g, ' ').replace(/\s*CLP\b/gi, '');

          this.handleClick = () => {
            const mainButton = document.querySelector('product-info .product-form__submit');
            if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
            mainButton.click();
          };

          this.syncPrice = () => {
            const priceRoot = this.productInfo.querySelector('[id^="price-"] .price');
            if (!priceRoot || !this.currentPrice || !this.comparePrice) return;
            const onSale = priceRoot.classList.contains('price--on-sale');
            const currentNode = onSale ? priceRoot.querySelector('.price__sale .price-item--sale') : priceRoot.querySelector('.price__regular .price-item--regular');
            const compareNode = onSale ? priceRoot.querySelector('.price__sale .price-item--regular') : null;
            if (currentNode?.textContent) this.currentPrice.textContent = this.cleanMoney(currentNode.textContent);
            if (this.showCompare && compareNode?.textContent) {
              this.comparePrice.textContent = this.cleanMoney(compareNode.textContent);
              this.comparePrice.hidden = false;
            } else {
              this.comparePrice.hidden = true;
            }
          };

          this.syncState = () => {
            const mainButton = document.querySelector('product-info .product-form__submit');
            if (!mainButton) return;
            const unavailable = mainButton.disabled;
            const busy = mainButton.getAttribute('aria-disabled') === 'true';
            this.stickyButton.disabled = unavailable || busy;
            const mainLabel = mainButton.querySelector('span')?.textContent?.trim();
            this.stickyButton.textContent = unavailable && mainLabel ? mainLabel : this.schemaLabel;
            if (mainButton !== this.visibilityTarget) {
              if (this.visibilityTarget) this.visibilityObserver.unobserve(this.visibilityTarget);
              this.visibilityTarget = mainButton;
              this.visibilityObserver.observe(this.visibilityTarget);
            }
          };

          this.syncAll = () => { this.syncState(); this.syncPrice(); };
          this.scheduleSync = () => { if (this.syncFrame) cancelAnimationFrame(this.syncFrame); this.syncFrame = requestAnimationFrame(this.syncAll); };
          this.visibilityObserver = new IntersectionObserver(([entry]) => {
            const passedMainButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', passedMainButton);
          }, { threshold: [0, 0.01] });
          this.productObserver = new MutationObserver(this.scheduleSync);
          this.productObserver.observe(this.productInfo, { attributes: true, childList: true, subtree: true, characterData: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
          this.stickyButton.addEventListener('click', this.handleClick);
          this.syncAll();
        }
        disconnectedCallback() {
          this.stickyButton?.removeEventListener('click', this.handleClick);
          this.productObserver?.disconnect();
          this.visibilityObserver?.disconnect();
          if (this.syncFrame) cancelAnimationFrame(this.syncFrame);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
